<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="galeriYukle"> galeri yükle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="galeriList"> galeri listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="galeriKaldir"> galeri kaldır
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import GaleriService from '../../../WSProvider/GaleriService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataYilmazlar = "";
    export default {
        name: "GaleriDetay",
        methods: {
            galeriYukle() {
                GaleriService.galeriYukle(["test.png", "deneme.png"]);
            },
            galeriList() {
                GaleriService.galeriList();
            },
            galeriKaldir() {
                GaleriService.galeriKaldir("GL-1005");
            },

        }
    }
</script>

<style scoped>

</style>